import type { MessengerWhatsappViewSettings } from '@widgets/messenger/types'
import { useWidgetChannels } from '@widgets/messenger/compositions/useWidgetChannels'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'
import { WebWidgetChannelType } from '@/data/models/domain/messages/settings/webWidget/types'

export const useWidgetWhatsappViewSettings = () => {
  const { widgetSettings } = useWidgetStore()
  const { channelMap } = useWidgetChannels()

  return computed<MessengerWhatsappViewSettings>(() => {
    const { suitableNumber, uiSettings } = widgetSettings.value.channels[WebWidgetChannelType.WHATSAPP]
    const { title, description, buttonText } = uiSettings.mainScreen

    return {
      channel: channelMap.value[WebWidgetChannelType.WHATSAPP],
      suitableNumber,
      title,
      description,
      buttonText,
      showQrCode: uiSettings.showQrCode,
    } satisfies MessengerWhatsappViewSettings
  })
}
